/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Cancel order request
 */
export interface CancelOrderRequestDto {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  /**
   * Order ID. If empty - cancel all active orders.
   */
  orderId?: number;
}
